import { render, staticRenderFns } from "./AccountRecoveryForm.vue?vue&type=template&id=01c5c592"
import script from "./AccountRecoveryForm.vue?vue&type=script&lang=js"
export * from "./AccountRecoveryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports